import { useEffect } from 'react';

interface LegalText {
  text: string;
  text2: string;
  terms: { text: string; url: string };
  privacy: { text: string; url: string };
}

interface TermsCheckboxProps {
  checked: boolean;
  onChange: (accepted: boolean) => void;
  legalText: LegalText;
  id?: string;
  compact?: boolean;
}

const LINK_HOVER_STYLE = `
  .terms-link { color: #2F86DD; text-decoration: underline; transition: color 0.2s ease; }
  .terms-link:hover { color: #1A5A9E; }
`;

const TermsCheckbox = ({
  checked,
  onChange,
  legalText,
  id = 'termsAgreement',
  compact = false,
}: TermsCheckboxProps) => {
  useEffect(() => {
    if (document.getElementById('terms-link-hover-style')) return;
    const style = document.createElement('style');
    style.id = 'terms-link-hover-style';
    style.textContent = LINK_HOVER_STYLE;
    document.head.appendChild(style);
  }, []);

  return (
    <div className="form-check" style={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: '0.3rem',
      fontSize: compact ? '0.78rem' : '0.85rem',
      color: '#6c757d',
      fontWeight: 400,
      marginBottom: compact ? '1.3rem' : '1rem',
    }}>
      <label className="form-check-label" style={{ cursor: 'pointer', flexShrink: 0 }}>
        <input
          type="checkbox"
          id={id}
          className="form-check-input"
          checked={checked}
          onChange={() => onChange(!checked)}
        />
        <span style={{ transform: 'scale(1.2)' }}></span>
      </label>
      <span style={{ lineHeight: 1.5, color: '#495057' }}>
        {legalText.text}{' '}
        <a href={legalText.terms.url} target="_blank" rel="noopener noreferrer" className="terms-link">
          {legalText.terms.text}
        </a>
        {' '}and{' '}
        <a href={legalText.privacy.url} target="_blank" rel="noopener noreferrer" className="terms-link">
          {legalText.privacy.text}
        </a>
        {' '}{legalText.text2}
      </span>
    </div>
  );
};

export default TermsCheckbox;
